import { RenewalConfirmationTranslations } from '../types';

export const renewalConfirmation: RenewalConfirmationTranslations = {
  title: "¡Renovación Confirmada!",
  subtitle: "Gracias por renovar tu confianza en Gándara International School",

  // Submission Details
  submissionDetails: "Detalles de tu Renovación",
  parentName: "Padre/Madre/Tutor",
  childrenEnrolled: "Niños/as Matriculados",
  submissionDate: "Fecha de Solicitud",
  referenceNumber: "Número de Referencia",

  // Payment Instructions
  paymentInstructions: "Instrucciones de Pago",
  bankAccount: "Cuenta Bancaria",
  accountNumber: "ES70 2100 5752 6202 0018 6824",
  recipient: "Beneficiario",
  recipientName: "NOGUERA Y VALDES SL",
  concept: "Concepto del Pago",
  amount: "Importe a Transferir",
  deadline: "Fecha Límite de Pago",
  earlyBirdDeadline: "28 de febrero de 2026 (descuento anticipado)",
  standardDeadline: "17 de marzo de 2026",

  // Pricing Breakdown
  pricingBreakdown: "Desglose de Costes",
  matriculaTotal: "Total Matrícula",
  annualTuitionTotal: "Total Cuotas Anuales (10 meses)",
  earlyBirdDiscount: "Descuento Matrícula Anticipada",
  annualPaymentDiscount: "Descuento Pago Anual",
  grandTotal: "Total General",

  // Next Steps
  nextSteps: "Próximos Pasos",
  steps: {
    transfer: "Realiza la transferencia bancaria con los detalles indicados arriba. No olvides incluir el concepto exacto para que podamos identificar tu pago.",
    sendConfirmation: "Envía el justificante de pago a info@gandaraschool.com",
    receiptConfirmation: "Confirmaremos la recepción de tu pago en un plazo de 2 días laborables",
    welcomeEmail: "Recibirás un correo de bienvenida en junio con toda la información para el inicio del curso 2026/2027"
  },

  // Contact Info
  contactInfo: "Información de Contacto",
  questionsContact: "¿Tienes alguna pregunta? Estamos aquí para ayudarte:",

  // Actions
  printConfirmation: "Imprimir Confirmación",
  backToHome: "Volver al Inicio"
};
